import styled from 'styled-components';

export const BrandPageTitle = styled.div`
  ${({ theme }) => theme.font.t1};
  font-style: normal;
  line-height: 120%;
  color: ${({ theme }) => theme.color.ui1};
`;
